import React, { useState } from 'react';
import { SignupData } from '../../../pages/SignupPage';
import { XIcon } from 'lucide-react';
interface ScoutFormProps {
  updateDetails: (details: any) => void;
  data: SignupData;
}
const ScoutForm: React.FC<ScoutFormProps> = ({
  updateDetails,
  data
}) => {
  const [organizationInput, setOrganizationInput] = useState('');
  const handleAddOrganization = () => {
    if (organizationInput.trim() !== '') {
      const currentOrgs = data.profileDetails?.organizations || [];
      updateDetails({
        organizations: [...currentOrgs, organizationInput.trim()]
      });
      setOrganizationInput('');
    }
  };
  const handleRemoveOrganization = (index: number) => {
    const currentOrgs = [...(data.profileDetails?.organizations || [])];
    currentOrgs.splice(index, 1);
    updateDetails({
      organizations: currentOrgs
    });
  };
  return <div className="space-y-4" data-id="element-188">
      <div data-id="element-189">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-190">
          Scouting Specialty
        </label>
        <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. Youth Talent, International Recruitment" value={data.profileDetails?.scoutingSpecialty || ''} onChange={e => updateDetails({
        scoutingSpecialty: e.target.value
      })} data-id="element-191" />
      </div>
      <div data-id="element-192">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-193">
          Years of Experience
        </label>
        <input type="number" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. 6" value={data.profileDetails?.experience || ''} onChange={e => updateDetails({
        experience: e.target.value
      })} data-id="element-194" />
      </div>
      <div data-id="element-195">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-196">
          Organizations Worked For
        </label>
        <div className="flex" data-id="element-197">
          <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg block w-full p-2.5" placeholder="e.g. Arsenal FC Scouting Network" value={organizationInput} onChange={e => setOrganizationInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && (e.preventDefault(), handleAddOrganization())} data-id="element-198" />
          <button type="button" className="bg-blue-600 text-white rounded-r-lg px-4" onClick={handleAddOrganization} data-id="element-199">
            Add
          </button>
        </div>
        <div className="mt-2" data-id="element-200">
          {(data.profileDetails?.organizations || []).map((org, index) => <div key={index} className="flex items-center bg-gray-100 rounded-lg px-3 py-2 mt-2" data-id="element-201">
              <span className="flex-1" data-id="element-202">{org}</span>
              <button type="button" className="text-gray-500 hover:text-red-500" onClick={() => handleRemoveOrganization(index)} data-id="element-203">
                <XIcon size={16} data-id="element-204" />
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};
export default ScoutForm;